import script from "./CryptoCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CryptoCard.vue?vue&type=script&setup=true&lang=ts"

import "./CryptoCard.vue?vue&type=style&index=0&id=98a79d14&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98a79d14"]])

export default __exports__